import * as tslib_1 from "tslib";
import * as React from "react";
import axios from "axios";
import { API_URL, ATTACH_SERVER, SITE_URL } from "../../config/urls";
import { toastr } from "react-redux-toastr";
import Regions from "../../components/Global/regions";
import { connect } from "react-redux";
var SuggestionUpdateView = /** @class */ (function (_super) {
    tslib_1.__extends(SuggestionUpdateView, _super);
    function SuggestionUpdateView(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            loading: false,
            suggestion: {},
            suggestion_new: {},
            files: [],
        };
        return _this;
    }
    SuggestionUpdateView.prototype.componentWillMount = function () {
        this.getSuggestion();
    };
    SuggestionUpdateView.prototype.render = function () {
        var sug = this.state.suggestion;
        var nsug = this.state.suggestion_new;
        var regionName = '';
        var regionNameN = '';
        Regions.regions.forEach(function (r) {
            if (r.guid === sug.region_fias) {
                regionName = r.name;
            }
            if (r.guid === nsug.region_fias) {
                regionNameN = r.name;
            }
        });
        if (sug.hasOwnProperty("id")) {
            return (React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-sm-6" },
                    React.createElement("div", { className: "m-portlet" },
                        React.createElement("div", { className: "m-portlet__body" },
                            React.createElement("div", { className: "d-flex flex-row" },
                                React.createElement("div", { className: "flex-grow-1" },
                                    React.createElement("div", null, sug.image && (React.createElement("img", { width: '200', src: sug.image, alt: "" }))),
                                    React.createElement("span", { className: "m-badge m-badge--wide " + (sug.status === 'new' ? 'm-badge--info' : (sug.status === 'approved' ? 'm-badge--success' : 'm-badge--danger')) }, sug.status === 'new' ? 'На модерации' : (sug.status === 'approved' ? 'Одобрено' : (sug.status === 'declined' ? 'Отклонено' : 'Снято с публикации пользователем'))),
                                    React.createElement("h2", null,
                                        sug.title,
                                        " (\u041E\u0440\u0438\u0433\u0438\u043D\u0430\u043B)"),
                                    React.createElement("div", null,
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435:  "),
                                            " ",
                                            sug.title),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:  "),
                                            " ",
                                            sug.description),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u0421\u0442\u0430\u0442\u0443\u0441:  "),
                                            " ",
                                            sug.status === 'new' ? 'На модерации' : (sug.status === 'approved' ? 'Одобрено' : (sug.status === 'declined' ? 'Отклонено' : 'Снято с публикации пользователем'))),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u0422\u0435\u043C\u0430:  "),
                                            " ",
                                            sug.theme.title),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041F\u043E\u0434\u0442\u0435\u043C\u0430:  "),
                                            " ",
                                            sug.subtheme.title),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u0413\u043E\u0440\u043E\u0434:  "),
                                            " ",
                                            sug.address),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u0420\u0435\u0433\u0438\u043E\u043D:  "),
                                            " ",
                                            regionName),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041E\u0442 \u044D\u043A\u0441\u043F\u0435\u0440\u0442\u0430:  "),
                                            " ",
                                            sug.is_expert ? 'Да' : 'Нет'),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438:  "))),
                                    React.createElement("div", { className: "d-flex flex-row justify-content-between" },
                                        React.createElement("div", { className: "flex-grow-1 justify-content-center center d-flex flex-row align-items-center" },
                                            React.createElement("div", { className: "user__photo", style: { borderRadius: '50%', width: 34,
                                                    height: 34, backgroundImage: "url(" + sug.user.avatar + ")",
                                                    backgroundPosition: 'center center', backgroundSize: 'cover',
                                                    backgroundRepeat: ' no-repeat' } }),
                                            React.createElement("div", { className: "mt-3" }, sug.user.surname + " " + sug.user.name)))),
                                React.createElement("div", { className: "d-flex flex-column" },
                                    React.createElement("a", { target: "_blank", href: SITE_URL + '/suggests/' + sug.id, className: "btn btn-link" }, "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043D\u0430 \u0441\u0430\u0439\u0442\u0435"))))),
                    (this.state.files && this.state.files.length > 0) && (React.createElement(React.Fragment, null,
                        "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u043B\u0435\u043D\u043D\u044B\u0435 \u0444\u0430\u0439\u043B\u044B:",
                        React.createElement("br", null),
                        this.state.files.map(function (f, idx) { return (React.createElement(React.Fragment, null,
                            React.createElement("a", { style: { display: 'contents' }, key: 'file-' + idx, href: f.link, target: '_blank' }, f.name),
                            React.createElement("br", null))); })))),
                React.createElement("div", { className: "col-sm-6" },
                    React.createElement("div", { className: "m-portlet" },
                        React.createElement("div", { className: "m-portlet__body" },
                            React.createElement("div", { className: "d-flex flex-row" },
                                React.createElement("div", { className: "flex-grow-1" },
                                    React.createElement("div", null, nsug.image && (React.createElement("img", { width: '200', src: nsug.image, alt: "" }))),
                                    React.createElement("h2", null,
                                        nsug.title,
                                        " (\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F)"),
                                    React.createElement("div", null,
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435:  "),
                                            " ",
                                            nsug.title),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:  "),
                                            " ",
                                            nsug.description),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u0422\u0435\u043C\u0430:  "),
                                            " ",
                                            nsug.theme.title),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041F\u043E\u0434\u0442\u0435\u043C\u0430:  "),
                                            " ",
                                            nsug.subtheme.title),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u0413\u043E\u0440\u043E\u0434:  "),
                                            " ",
                                            nsug.address),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u0420\u0435\u0433\u0438\u043E\u043D:  "),
                                            " ",
                                            regionNameN),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041E\u0442 \u044D\u043A\u0441\u043F\u0435\u0440\u0442\u0430:  "),
                                            " ",
                                            nsug.is_expert ? 'Да' : 'Нет'),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: "black font-weight-bold" }, " \u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438:  "))),
                                    React.createElement("div", { className: "d-flex flex-row justify-content-between" },
                                        React.createElement("div", { className: "flex-grow-1 justify-content-center center d-flex flex-row align-items-center" },
                                            React.createElement("div", { className: "user__photo", style: { borderRadius: '50%', width: 34,
                                                    height: 34, backgroundImage: "url(" + nsug.user.avatar + ")",
                                                    backgroundPosition: 'center center', backgroundSize: 'cover',
                                                    backgroundRepeat: ' no-repeat' } }),
                                            React.createElement("div", { className: "mt-3" }, nsug.user.surname + " " + nsug.user.name)))),
                                React.createElement("div", { className: "d-flex flex-column" },
                                    React.createElement("button", { type: "button", onClick: this.changeStatus.bind(this), className: "btn btn-success mb-2 m-btn m-btn--custom m-btn--bolder m-btn--uppercase" }, "\u041E\u0434\u043E\u0431\u0440\u0438\u0442\u044C"))))),
                    (this.state.filesN && this.state.filesN.length > 0) && (React.createElement(React.Fragment, null,
                        "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u043B\u0435\u043D\u043D\u044B\u0435 \u0444\u0430\u0439\u043B\u044B:",
                        React.createElement("br", null),
                        this.state.filesN.map(function (f, idx) { return (React.createElement(React.Fragment, null,
                            React.createElement("a", { style: { display: 'contents' }, key: 'file-' + idx, href: f.link, target: '_blank' }, f.name),
                            React.createElement("br", null))); }))))));
        }
        else {
            return React.createElement("div", null, "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
        }
    };
    SuggestionUpdateView.prototype.getSuggestion = function () {
        var _this = this;
        this.setState({ loading: true });
        axios.get(API_URL + '/suggestion/get-update/' + this.props.match.params.id, {
            headers: { 'Authorization': this.props.auth_token },
        }).then(function (resp) {
            _this.setState({
                suggestion: resp.data.data && resp.data.data.suggestion ? resp.data.data.suggestion : {},
                suggestion_new: resp.data.data && resp.data.data.update ? resp.data.data.update : {},
                loading: false
            }, function () {
                if (_this.state.suggestion && _this.state.suggestion.files && _this.state.suggestion.files.length > 0) {
                    var files_1 = [];
                    _this.state.suggestion.files.forEach(function (fileId) {
                        axios.get(ATTACH_SERVER + '/attach/' + fileId).then(function (r) {
                            if (r.data && r.data.data && r.data.data.link) {
                                files_1.push({ link: r.data.data.link, name: r.data.data.name, size: r.data.data.size });
                                _this.setState({ files: files_1 });
                            }
                        }).catch(function (e) { return console.log(e); });
                    });
                }
                if (_this.state.suggestion_new && _this.state.suggestion_new.files && _this.state.suggestion_new.files.length > 0) {
                    var filesN_1 = [];
                    _this.state.suggestion_new.files.forEach(function (fileId) {
                        axios.get(ATTACH_SERVER + '/attach/' + fileId).then(function (r) {
                            if (r.data && r.data.data && r.data.data.link) {
                                filesN_1.push({ link: r.data.data.link, name: r.data.data.name, size: r.data.data.size });
                                _this.setState({ filesN: filesN_1 });
                            }
                        }).catch(function (e) { return console.log(e); });
                    });
                }
            });
        }).catch(function (error) {
            if (error.response && error.response.status === 403) {
                toastr.error('Ошибка', 'У Вас недостаточно прав');
            }
        });
    };
    SuggestionUpdateView.prototype.changeStatus = function () {
        var _this = this;
        var result = confirm('Вы уверены, что хотите подтвердить изменение предложения?');
        if (result) {
            axios.post(API_URL + '/suggestion/approve-update/' + this.props.match.params.id, {}, {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.props.history.push('/suggestions-update/');
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    return SuggestionUpdateView;
}(React.Component));
export default connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
}); })(SuggestionUpdateView);



//////////////////
// WEBPACK FOOTER
// ./src/views/suggestionsupdates/view.tsx
// module id = 551
// module chunks = 0